export default "__VITE_ASSET__BDdRA$uU__"